import { useEffect, useState } from "react";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db, auth } from "../firebase";
import { signOut } from "firebase/auth";

import Header from "../components/Header";
import TransactionForm from "../components/TransactionForm";
import TransactionTable from "../components/TransactionTable";
import StatsCards from "../components/StatsCards";
import Charts from "../components/Charts";

export default function Dashboard() {
  const [transactions, setTransactions] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [defaultType, setDefaultType] = useState("");

  // Fetch transactions
  const fetchTransactions = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "transactions"));

      const data = querySnapshot.docs.map((item) => ({
        id: item.id,
        ...item.data(),
      }));

      setTransactions(data);
    } catch (error) {
      console.log("Fetch Error:", error);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  // Add transaction
  const addTransaction = async (transaction) => {
    try {
      const tempTransaction = {
        ...transaction,
        id: Date.now().toString(),
      };

      setTransactions((prev) => [...prev, tempTransaction]);

      await addDoc(collection(db, "transactions"), transaction);

      fetchTransactions();
    } catch (error) {
      console.log("Add Error:", error);
    }
  };

  // Delete transaction
  const deleteTransaction = async (id) => {
    try {
      setTransactions((prev) =>
        prev.filter((transaction) => transaction.id !== id)
      );

      if (!id.includes("-")) {
        await deleteDoc(doc(db, "transactions", id));
      }

      fetchTransactions();
    } catch (error) {
      console.log("Delete Error:", error);
    }
  };

  // Reset all balance

// Replace your resetBalance function in Dashboard.js with this FAST version:

const resetBalance = async () => {
  try {
    // Instant UI clear FIRST
    setTransactions([]);

    // Fetch all docs
    const querySnapshot = await getDocs(collection(db, "transactions"));

    // Delete in background
    const deletePromises = querySnapshot.docs.map((item) =>
      deleteDoc(doc(db, "transactions", item.id))
    );

    await Promise.all(deletePromises);
  } catch (error) {
    console.log("Reset Error:", error);

    // If something fails, restore correct Firebase state
    fetchTransactions();
  }
};

  return (
    <div>
      <Header logout={() => signOut(auth)} />

      <StatsCards
        transactions={transactions}
        resetBalance={resetBalance}
        openIncome={() => {
          setDefaultType("income");
          setFormOpen(true);
        }}
        openExpense={() => {
          setDefaultType("expense");
          setFormOpen(true);
        }}
      />

      <TransactionForm
        addTransaction={addTransaction}
        open={formOpen}
        setOpen={setFormOpen}
        defaultType={defaultType}
      />

      <Charts transactions={transactions} />

      <TransactionTable
        transactions={transactions}
        deleteTransaction={deleteTransaction}
      />
    </div>
  );
}